import {inject} from "aurelia-framework";
import {OperationInterface} from "./operation.interface";
import {DialogService} from "aurelia-dialog";
import {BulkOperationQueryCore} from "./utility/bulk-operation-query-core";
import {RemoveTagView} from "./utility/remove-tag-view";
import {I18N} from "aurelia-i18n";

@inject(
    DialogService,
    BulkOperationQueryCore,
    I18N
)
export class RemoveTag extends OperationInterface {
    constructor(dialogService, bulkOperationQueryCore, i18n) {
        super();
        this.dialogService = dialogService;
        this.bulkOperationQueryCore = bulkOperationQueryCore;
        this.i18n = i18n;
    }

    /*public*/
    getName() {
        return 'remove-tag';
    }

    /*public*/
    execute(context) {
        return this.dialogService.open({
            viewModel: RemoveTagView,
            model: {
                title: 'media-database.bulk-operation.remove-tag.title',
                items: context.items,
                onSave: this.onSaveCallback(context).bind(this),
            }
        }).whenClosed();
    }

    /*public*/
    getActions(items, operationConfig) {
        return [
            {
                type: 'bulk-operation',
                operationConfig: operationConfig,
                label: this.i18n.tr('media-database.bulk-operation.remove-tag.title'),
            }
        ];
    }

    /*private*/
    onSaveCallback(context) {
        return (selectedTags) => {
            return this.bulkOperationQueryCore.query(
                context.operationConfig.type,
                {
                    items: context.items,
                    tags: selectedTags,
                }
            );
        };
    }
}
